import { render } from "./QueueValues.vue?vue&type=template&id=165d4302&class=w-100"
import script from "./QueueValues.vue?vue&type=script&lang=js"
export * from "./QueueValues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__